import router from '@core/router';
import axios from 'axios';
axios.defaults.baseURL = (window._env_ && window._env_.VUE_APP_API_URL) || process.env.VUE_APP_API_URL;

/*
* create api instance
*/
const api = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

api.interceptors.request.use((config) => {
  config.headers['X-Locale'] = localStorage.getItem('currentLocale') || 'de-AT';

  return config;
}, (error) => {
  const route = (error) ? 'error' : 'login';

  router.replace({
    name: route
  });
});

export default api;
